import { useIntl } from 'react-intl';

import useAuth from 'src/hooks/useAuth';
import { capitalizeFirstLetter } from 'src/utils/string';

import { BOW_TIE_SIDE } from '../constants';

function LegendItem({ type, label }) {
  return (
    <span className="bow-tie__legend-item">
      <span
        className={`bow-tie__legend-swatch bow-tie__legend-swatch--${type}`}
      />
      {label}
    </span>
  );
}

function BowTieLegend() {
  const intl = useIntl();
  const { terms: resources } = useAuth();

  return (
    <div className="bow-tie__legend">
      <LegendItem
        type="cause"
        label={capitalizeFirstLetter(resources?.pontosproblematicos || '')}
      />
      <LegendItem
        type="consequence"
        label={capitalizeFirstLetter(resources?.consequencias || '')}
      />
      <LegendItem
        type={BOW_TIE_SIDE.PREVENTIVO}
        label={capitalizeFirstLetter(
          intl.formatMessage(
            { id: 'controlePreventivo' },
            { pontodecontrole: resources?.pontodecontrole }
          )
        )}
      />
      <LegendItem
        type={BOW_TIE_SIDE.CORRETIVO}
        label={capitalizeFirstLetter(
          intl.formatMessage(
            { id: 'controleCorretivo' },
            { pontodecontrole: resources?.pontodecontrole }
          )
        )}
      />
      <LegendItem
        type="risk"
        label={capitalizeFirstLetter(resources?.risco || '')}
      />
    </div>
  );
}

export default BowTieLegend;
